import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import scheduledPostsReducer from '../reducers/scheduledPostsReducer';

const configureStore = (railsProps) => (
  createStore(scheduledPostsReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
